import BasePropertyView from 'BasePropertyView.js';
import RestService from 'RestService.js';
import mathUtil from 'util/MathUtil.js';
import util from 'util/Util.js';
import TextUtil from 'util/TextUtil.js';
import constants from 'Constants.js';
import nameTemplate from 'properties/main/file-size.ejs';


class MainFileSizeView extends BasePropertyView {

    initialize( opts ) {
        this.options = opts || {};
        this.template = nameTemplate;
        this.tagName = 'div';
        this.id = opts.el;
        this.config = opts.config || {};
        this.maxSize=RestService.getProfile().MaxAttachmentSize;

        this.events = {
            'change input[type=text]' : 'updateAttributes',
            'change input[type=number]' : 'updateAttributes',
            'blur input[type=text], input[type=number]'   : 'lostFocus',
            'focus input[type=text], input[type=number]'   : 'getFocus',
            'click #btn-up-fSize,#btn-down-fSize':'changeFileSize'
        };
        this.setFileSize();
        return this;
    }
    changeFileSize(){
        $('#fileSize').trigger('change');
    }
    isInt(value) {

        var er = /^-?[0-9]+$/;
        return er.test(value);
    }

    setFileSize() {
        // If there is already a max Size defined in the profile in Mb.
        if (this.maxSize && this.maxSize > 0) {
            let maxSizeInMb=mathUtil.convertBytesToMb(parseInt(this.maxSize));
            let propValSizeInMb=mathUtil.convertBytesToMb(parseInt(!this.model.get('maxSize') ? this.maxSize :this.model.get('maxSize') ));

            if(propValSizeInMb > maxSizeInMb){
                propValSizeInMb = mathUtil.convertBytesToMb(parseInt(this.model.get('maxSize')));//maxSizeInMb;
            }

            let sizeBytes = mathUtil.convertMbToBytes(propValSizeInMb);

            this.model.set('maxSize',sizeBytes, {silent: true});
            this.model.set('fileSize', Math.floor(propValSizeInMb), {silent: true});
            // If not assign one by default.
        } else {
            this.model.set('maxSize', constants.DEFAULT_FILE_SIZE_BYTES, {silent:true});
            this.model.set('fileSize', constants.DEFAULT_FILE_SIZE_MB, {silent: true});
        }
    }

    updateAttributes(ev) {
        ev.preventDefault();
        let propName = ev.currentTarget.name,
            propVal  = ev.currentTarget.value,
            maxSizeInMb=mathUtil.convertBytesToMb(parseInt(this.maxSize));

        if (!this.isInt(propVal)) {
            propVal =mathUtil.convertBytesToMb(parseInt(this.model.get('maxSize')));
        }

        // If the input value rebase the size that the current user is allowed. Leave the user max size.
        if(parseInt(propVal) > maxSizeInMb || parseInt(propVal)<=0){
            propVal=mathUtil.convertBytesToMb(parseInt(this.model.get('maxSize')));//maxSizeInMb;
        }

        // Storing the size in bytes.
        let sizeBytes = mathUtil.convertMbToBytes(propVal);

        this.model.set( propName, Math.floor(propVal), {silent: true} );
        this.model.set( 'maxSize', sizeBytes, {silent: true});
        this.render();
    }


    render() {
        this.$el.empty();
        if(this.template) {
            this.$el.html(this.template(this.model.toJSON()));
        }

        if (this.config.showTitle) {
            this.$el.find('.propTitle').removeClass('hide');
        }
        $('.spinFileSize .btn:first-of-type').on('click', function() {
            $('.spinFileSize input').val( parseInt($('.spinFileSize input').val(), 10) + 1 );
        });
        $('.spinFileSize .btn:last-of-type').on('click', function() {
            $('.spinFileSize input').val( parseInt($('.spinFileSize input').val(), 10) - 1 );
        });
        this.delegateEvents();
        return this;
    }
}

export default MainFileSizeView;
